import React from 'react';

import TabBtnLeft from '/assets/icon/global/tab-btn-left.svg';
import TabBtnRight from '/assets/icon/global/tab-btn-right.svg';
import FormTabXBlack from '/assets/icon/global/form-tab-x-black.svg';
import FormTabXWhite from '/assets/icon/global/form-tab-x-white.svg';

interface IProps {
  tabList: { label: string; value: string }[];
  activeTab: string;
  setActiveTab: any;
  tabContents: any;

  className?: string;
  style?: React.CSSProperties;
  isX?: any;
  xAction?: any;
}
const CustomTab = (props: IProps) => {
  const onActionLeft = () => {
    const currentIndex = props.tabList.findIndex((tab) => tab.value === props.activeTab);
    const index = currentIndex - 1;
    if (index < 0) return;

    props.setActiveTab(props.tabList[index].value);
  };

  const onActionRight = () => {
    const currentIndex = props.tabList.findIndex((tab) => tab.value === props.activeTab);
    const index = currentIndex + 1;
    if (index > props.tabList.length - 1) return;

    props.setActiveTab(props.tabList[index].value);
  };

  return (
    <>
      <div className={`custom-tab ${props.className || ''}`} style={props.style}>
        <div className="tab-buttons" role="tablist" aria-label="tabs">
          <div className="tab-button-list">
            {props.tabList?.map((item, idx) => (
              <div key={idx} className={'tab-button'}>
                <div
                  role="tab"
                  onClick={() => props.setActiveTab(item.value)}
                  className={`tab-button-label ${props.activeTab == item.value ? 'active' : ''}`}
                >
                  <span className={'tab-label-text'}>{item.label}</span>
                  {props.isX && (
                    <a
                      className={'tab-button-x'}
                      onClick={(e: any) => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.xAction?.(item, idx);
                      }}
                    >
                      <img
                        src={props.activeTab == item.value ? FormTabXWhite : FormTabXBlack}
                        alt={'tab-x'}
                        style={{ width: '15px', height: '15px', cursor: 'pointer' }}
                      />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className={'tab-paging'}>
            <button onClick={onActionLeft}>
              <img src={TabBtnLeft} />
            </button>
            <div className={'tab-paging-text'}>
              <span>{props.tabList.findIndex((tab) => tab.value === props.activeTab) + 1}</span>
              <span>to</span>
              <span>{props.tabList.length}</span>
            </div>
            <button onClick={onActionRight}>
              <img src={TabBtnRight} />
            </button>
          </div>
        </div>

        <div className="custom-tab-content">{props.tabContents}</div>
      </div>
    </>
  );
};

export default CustomTab;
